import createComponentPreset from "../../../../../fabrics/createComponentPreset";
import { createDisplayNameForMediaElement } from "../../../utils/getDisplayName";
import { createTestIdForMediaElement } from "../../../utils/getTestId";
import Addon from "../Addon/MediaAddon";

import classes from "./MediaBottomRightAddon.styl";

const BOTTOM_RIGHT_ADDON_DISPLAY_NAME = "BottomRightAddon";
const BOTTOM_RIGHT_ADDON_TEST_ID = createTestIdForMediaElement(
    BOTTOM_RIGHT_ADDON_DISPLAY_NAME,
);

/**
 * @deprecated
 * Используйте вместо этого компонента UniBoxAdditional / UniBoxMain
 */
export const BottomRightAddon = createComponentPreset(
    BOTTOM_RIGHT_ADDON_DISPLAY_NAME,
    Addon,
    {
        className: classes.addon,
        "data-tsid": BOTTOM_RIGHT_ADDON_TEST_ID,
    },
);

BottomRightAddon.displayName = createDisplayNameForMediaElement(
    BOTTOM_RIGHT_ADDON_DISPLAY_NAME,
);

export default BottomRightAddon;
